import { useState, useMemo, FunctionComponent, useEffect, useRef } from "react";
import alerticonError from "../../assets/dropdown/alert-icon-error.svg";
import otlchevronforward1 from "../../assets/dropdown/otlchevronforward1@2x.png";

interface InputsDropdownProps {
    label?: string;
    placeHolder?: string;
    propMinWidth?: string;
    options: any;
    onSelect?: any;
    errorMessage?: any;
    payerName?: any;
    payerId?: any;
    initialValue?: string;
    disableDropdown?: boolean;
    showSearchable?: boolean;
    clearSelected?: any;
    errorMessage1?: any;
    // setClearSelected?:any
    pageType?: any;
    singleSelect?: any
    dropdownClick?: any
}

const InputsDropdown: FunctionComponent<InputsDropdownProps> = ({
    label,
    placeHolder,
    propMinWidth,
    options,
    onSelect,
    errorMessage,
    payerName,
    payerId,
    initialValue,
    disableDropdown,
    showSearchable,
    errorMessage1,
    clearSelected,
    // setClearSelected
    pageType,
    singleSelect,
    dropdownClick
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(
        initialValue || placeHolder
    );
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (clearSelected) {
            setSelectedOption(placeHolder);
        }
    }, [clearSelected]);

    // Effect to handle initial value setting
    useEffect(() => {
        if (initialValue === null) {
            setSelectedOption(placeHolder);
        }

        if (
            initialValue !== undefined &&
            initialValue !== "" &&
            initialValue !== null
        ) {
            setSelectedOption(initialValue);
        }
    }, [initialValue]);

    useEffect(() => {
        if (payerId && payerName) {
            handleOptionSelect(payerId, payerName);
        }
    }, [payerId, payerName]);

    // If one item then select
    useEffect(() => {
        if (options?.length === 1 && singleSelect && options[0]?.name?.length > 0) {
            handleOptionSelect(options[0]?.key, options[0]?.name, options[0]?.type);
        }
    }, [options, options?.length > 0 ? options[0]?.key : null, singleSelect, pageType, options?.length > 0 ? options[0]?.id : null]);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    const content1Style = useMemo(() => {
        return {
            minWidth: propMinWidth,
        };
    }, [propMinWidth]);

    function handleDropdownToggle(e: any) {
        if (!disableDropdown) {
            setIsOpen(!isOpen);
            if (dropdownClick) {
                dropdownClick(e)
            }
        }
    }

    function handleOptionSelect(
        key: any,
        name: any,
        type?: any,
        index?: any,
        matchedArray?: any
    ) {
        setSelectedOption(name);
        setIsOpen(false);
        // setClearSelected(false)
        if (onSelect) {
            onSelect(key, name, type, index, matchedArray);
        }
    }

    // Determine border class based on errorMessage
    const borderClass =
        errorMessage || errorMessage1
            ? "border-2 border-rose-500 dark:border-rose-500 darkinputborder"
            : "border-surface-border";

    return (
        <div
            id="addinterration-blg-dv"
            className={`relative flex-1 inputnew-div cts-flex1-remd flex flex-col items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg min-w-full`}
            ref={dropdownRef}
        >
            <label className="self-stretch relative font-semibold pb-2 dark:text-white">
                {label}
            </label>
            <div className="self-stretch flex flex-col items-start justify-start text-text-text-secondary dark:text-white">
                <div
                    id="cts-dropdown-dv"
                    className={`inputborder_css_dv  input-dropdown-dynamic-table self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary dark:bg-slate-700 overflow-hidden h-[21px] flex flex-row items-center justify-start py-2.5 px-[15px] gap-[8px] border-[1px] border-solid ${borderClass} mq450:flex-nowrap ${disableDropdown ? "caretask_dropdowndisbale" : ""
                        }`}
                    onClick={handleDropdownToggle}
                >
                    <div
                        className="flex-1 flex flex-row items-center justify-start cts-dropdown-wrap-dv "
                        style={content1Style}
                    >
                        <div className="flex-1 relative content-dropdown-wrap-dv ">
                            {selectedOption}
                        </div>
                    </div>
                    <img
                        className={`input-dropdown-dynamic-table h-4 w-4 relative overflow-hidden shrink-0 object-contain dark-white-img transform transition-transform ${isOpen ? "rotate-180" : ""
                            }`}
                        alt=""
                        src={otlchevronforward1}
                    />
                </div>
                {isOpen && (
                    <div className="cts-zindex-dv absolute left-0 mt-11 w-full self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-white border-[1px] border-solid border-surface-border z-50">
                        {options?.length > 0 ? (
                            options?.map((option: any, index: any) => (
                                <div
                                    key={index}
                                    className="py-2 px-[15px] hover:bg-gray-100 dark:hover:dark:bg-slate-500 cursor-pointer input-dropdown-dynamic-table"
                                    onClick={() =>
                                        handleOptionSelect(
                                            option.key,
                                            option.name,
                                            option.type,
                                            option.index,
                                            option.matchedArray
                                        )
                                    }
                                >
                                    {option.name}
                                </div>
                            ))
                        ) :
                            // pageType == "shift" ? (
                            <div className="py-2 px-[15px] text-center text-gray-500">
                                No options found
                            </div>
                            // ) : 
                            // (
                            //   ""
                            // )
                        }
                    </div>
                )}
            </div>
            {errorMessage && (
                <p className="text-red p-2 my-0 cts-bg-error flex items-center gap-[4px] ctcerror-width-blg mt-2">
                    <img src={alerticonError} alt="" /> {errorMessage.message}
                </p>
            )}
        </div>
    );
};

export default InputsDropdown;
